module.exports = __webpack_public_path__ + "img/title04_solgan.ac48d7ea.png";